import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-promocion-condiciones',
  templateUrl: './promocion-condiciones.component.html',
  styleUrls: ['./promocion-condiciones.component.css']
})

export class PromocionCondicionesComponent implements OnInit {
  gridApi             : any;
  gridColumnApi       : any;
  columnDefs          = [];
  frameworkComponents : any;
  listGetAllCondicion : any[];
  verFormAddCondicion = false;
  public idPromo      : string;
  public tituloModal  : string;
  public isCreate     : boolean = true;
  // T.20331 Essential: nuevas cond. para promos
  public tituloCard   : any;
  public condicion    : string;
  public defineLista   = [];
  public camposGrid    = [];

  get idCondicion() {
    return this.listGetAllCondicion.map((item) => item.id_tiers);
  }

  constructor(
    private readonly route              : ActivatedRoute,
    private readonly promocionesService : PromocionesService,
    private readonly _util              : UtilsService
  ) {

  }

  ngOnInit(): void {
    const pathSegments = this.route.snapshot.url.map(segment => segment.path);
    this.condicion = pathSegments[pathSegments.length - 1];    

    // get valos de ruta, corresponde al id promo
    this.route.params.subscribe((params) => {
      const id = params['id'] as string
      if (id) {
        this.idPromo = id;
        console.log('id promo actual', id);
        //this.cargarCondicionPorPromocion(this.idPromo);
        if(this.condicion == 'tiers'){
          this.cargarCondicionPorPromocion(this.idPromo);
        }else{
          this.listDemasCondicion(this.idPromo);
        }
      }
    });

    this.tituloCard = this.idPromo + " condición por " + this.condicion;
    this.gridComponent();
  }

  onGridReady(params){
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //params.api.sizeColumnsToFit();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefs = [{field: 'id_promo', sortable: true}];

    if(this.condicion == 'tiers'){
      this.columnDefs.push(
        {field: 'id_tiers', sortable: true},
        {headerName: 'Detalle', field: 'name_tiers', sortable: true, filter: true}
      );
    }
     
    if(this.condicion == 'agrupacionTarifa'){
      this.columnDefs.push(
        {field: 'id_sub_canal', sortable: true},
        {field: 'name_sub_canal', sortable: true, filter: true, headerName: 'Detalle'}
      );
    }

    if(this.condicion == 'canalVendedor'){
      this.columnDefs.push(
        {field: 'id_canal_cliente', sortable: true},
        {field: 'name_canal_cliente', sortable: true, filter: true, headerName: 'Detalle'});
    }

    this.columnDefs.push({
      cellRenderer: 'buttonRenderer',
      width: 40,
      cellStyle: {padding: 0},
      cellRendererParams: {
        onClick: this.eliminarCondicion.bind(this),
        label: 'Eliminar', colorBoton: 'btn btn-danger btn-block',
      },
    });

    console.log('Columna del Grid columnDefs:', this.columnDefs);
    console.log('Columna del Grid camposGrid: ', this.camposGrid);
  }

  nuevaCondicion(){
    this.verFormAddCondicion = true;
    this.isCreate = true;
    this.tituloModal = "Agregar condición a promoción " + this.idPromo;
    this.openModal();
  }

  back(){
    this.verFormAddCondicion = false;
    this.closeModal();
  }

  //GET ALL, de toda la condicion ligada a la promo
  cargarCondicionPorPromocion(id_promo) {
      this.promocionesService.getAllCondicionPorTier(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.listGetAllCondicion = resp;
        } else {
          this.listGetAllCondicion = [];
    }
      },
      (error) => {
        this.listGetAllCondicion = [];
      }
      );
  }

  eliminarCondicion({ rowData }) {
    // Obtener las claves del objeto para acceder al indice
    let keys = Object.keys(rowData);
    let propiedad = keys[2];
    let idCondcion = rowData[propiedad];
    console.log("Objeto a Eliminar", rowData);

    this._util.confirmarSincronoPromesa({
      title: '¿Esta seguro de eliminar la Condición ' + idCondcion + '?',
      action: 'Eliminar',
      //  funcion: this.promocionesService.borrarCondicionPorTier(rowData),
      funcion: this.deleteCondicion(rowData),
      })
      .then((res: any) => {
        //this.cargarCondicionPorPromocion(this.idPromo);
        this.getAllCondiciones(this.idPromo);
    });
  }

  guardarNuevaCondicion(payload: any) {
    console.log("Objeto a Crear", payload);

    this._util.confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        action: 'Nuevo',
        //funcion: this.promocionesService.addCondAgrupacionTarifa(payload),
        funcion: this.addCondicion(payload),
      }).then((res: any) => {
        //this.cargarCondicionPorPromocion(this.idPromo);
        this.getAllCondiciones(this.idPromo);
        //this.verFormAddCondicion = false; -- mantengo abierto el modal y mostrando el form
      });
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }
  
  // T.20331 Essential: nuevas cond. para promos
  getAllCondiciones(idPromo){
    console.log("condicion ACtual", this.idCondicion);
    if(this.condicion == 'tiers'){
      this.cargarCondicionPorPromocion(idPromo);
    }else{
      this.listDemasCondicion(idPromo);
    }
  }

  listDemasCondicion(id_promo){
    this.listGetAllCondicion = [];

    //OBTIENE LISTADO DE PARAMETRIZACION DE CONDICION AGRUPACION TARIFA CANAL
    if(this.condicion == 'agrupacionTarifa'){
      this.promocionesService.getAllCondAgrupacionTarifa(id_promo.trim()).subscribe(
        (resp) => { this.listGetAllCondicion = resp; }
      );
    }
    //OBTIENE LISTADO DE PARAMETRIZACION DE CONDICION DE CANAL VENDEDOR
    if(this.condicion == 'canalVendedor'){
      this.camposGrid = [
        {field: 'idCanal', sortable: true},
        {field: 'descCorta', sortable: true, filter: true, headerName: 'Detalle'}
      ];
      this.promocionesService.getAllCondCanalVendedor(id_promo.trim()).subscribe(
        (resp) => { this.listGetAllCondicion = resp; }
      );
    }
  }

  addCondicion(payload: any[]): Observable<any>{
    let response: any;
    if(this.condicion == 'tiers'){
      response = this.promocionesService.addCondicionPorTier(payload);
    }
    if(this.condicion == 'agrupacionTarifa'){
      response = this.promocionesService.addCondAgrupacionTarifa(payload);
    }
    if(this.condicion == 'canalVendedor'){
      response = this.promocionesService.addCondCanalVendedor(payload);
    }    
    return response;
  }

  deleteCondicion(payload){
    let response: any;
    if(this.condicion == 'tiers'){
      response = this.promocionesService.borrarCondicionPorTier(payload);
    }
    if(this.condicion == 'agrupacionTarifa'){
      response = this.promocionesService.borrarCondAgrupacionTarifa(payload);
    }
    if(this.condicion == 'canalVendedor'){
      response = this.promocionesService.borrarCondCanalVendedor(payload);
    }    
    return response;
  }

  recibeColumnasGrid(listaGrid){    
    console.log('Lista padre', this.columnDefs);
    console.log('Lista hijo:', listaGrid);

    this.defineLista = listaGrid;
    this.columnDefs.push(listaGrid);
  }

}